/* eslint-disable @typescript-eslint/naming-convention */
export enum DialogButtonText {
  ok = 'OK',
  cancel = 'Cancel',
  yes = 'Yes',
  no = 'No',
  continue = 'Continue',
}
